// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__16m7E","actions":"GroupTable_actions__2Kiyl","deleteModalFooter":"GroupTable_deleteModalFooter__1ry4m"};